require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./investments-meet-our-retirement-advisors.json") })
        }
      }, "path---investments-meet-our-retirement-advisors");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---investments-meet-our-retirement-advisors!./.cache/json/investments-meet-our-retirement-advisors.json
// module id = 2650
// module chunks = 231608221292675